import { DOCUMENT, NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '../../core/services/translation.service';
import { Subject } from 'rxjs';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { ProfileMenuComponent } from '../../features/manage-account/components/profile-menu/profile-menu.component';
import { UserData } from '../../features/manage-account/models/user-data';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { CurrencySelectorComponent } from '../currency-selector/currency-selector.component';
import { PopupLogoutComponent } from '../../shared/components/popup-logout/popup-logout.component';
@Component({
  selector: 'app-main-nav-bar',
  imports: [
    NgClass,
    FormsModule,
    TranslateModule,
    RouterLink,
    ProfileMenuComponent,
    PopupLogoutComponent,
    LanguageSelectorComponent,
    CurrencySelectorComponent,
  ],
  templateUrl: './main-nav-bar.component.html',
  styleUrl: './main-nav-bar.component.css',
})
export class MainNavBarComponent {
  @Input() isHomePage: boolean = false;
  @Input() isOverlayed: boolean = false;

  readonly translationService = inject(TranslationService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  readonly document = inject(DOCUMENT);
  readonly isLoggedIn = this.authService.isCustomerLoggedIn;

  destroy$ = new Subject<void>();

  countries = [
    {
      code: 'EGP',
      translation: 'مصر',
      currency: 'Pound (EGP)',
      icon: 'https://flagcdn.com/eg.svg',
    },
    {
      code: 'EUR',
      translation: 'إيطاليا',
      currency: 'Euro (EUR)',
      icon: 'https://flagcdn.com/it.svg',
    },
    {
      code: 'USD',
      translation: 'أمريكا',
      currency: ' U.S Dollar (USD)',
      icon: 'https://flagcdn.com/us.svg',
    },
  ];

  currencyDropdownOpended = false;
  selectedCurrency = this.countries[0].code;
  selectedIconCurrency = this.countries[0].icon;

  isDark = false;
  isMenuOpen = false;

  accessToken = '';

  popupIsOpen = false;
  user!: UserData;

  ngOnInit(): void {
    this.isDark = localStorage.getItem('theme') === 'dark';
    if (this.isDark) {
      document.documentElement.classList.add('dark');
      this.document.documentElement.style.background = '#1e1e48';
    }
    this.router.events.subscribe(() => this.closeSideMenu());
  }

  goBack() {
    this.removePassengerData();

    window.history.back();
  }

  removePassengerData() {
    sessionStorage.removeItem('passengerForm');
    sessionStorage.removeItem('primaryContact');
    sessionStorage.removeItem('billingAddress');
    sessionStorage.removeItem('billingSelectedAddress');
    sessionStorage.removeItem('masterOrderDrafted');
  }

  setTheme(theme: 'dark' | 'light') {
    this.isDark = theme === 'dark';
    if (this.isDark) {
      this.document.documentElement.classList.add('dark');
      this.document.documentElement.style.background = '#1e1e48';

      localStorage.setItem('theme', 'dark');
    } else {
      this.document.documentElement.classList.remove('dark');
      this.document.documentElement.style.background = '#ffffff';

      localStorage.setItem('theme', 'light');
    }
  }

  toggleCurrencyDropdown() {
    this.currencyDropdownOpended = !this.currencyDropdownOpended;
  }

  selectCurrency(code: string, icon: string) {
    this.selectedCurrency = code;
    this.selectedIconCurrency = icon;
    this.currencyDropdownOpended = false;
  }

  get lang() {
    return localStorage.getItem('lang');
  }

  get isRTL() {
    return this.lang === 'ar';
  }
  /////////////////////////////////////////////

  loginWithPopup() {
    // The service loads the profile and sends business roles to the partner area
    this.authService.loginWithPopup().subscribe({
      error: (err) => this.authService.showLoginError(err),
    });
  }

  openSideMenu() {
    this.isMenuOpen = true;
    this.document.body.style.overflow = 'hidden';
  }

  closeSideMenu() {
    this.isMenuOpen = false;
    this.document.body.style.overflow = 'auto';
  }

  openPopupLogout() {
    this.popupIsOpen = true;
  }

  closePopup() {
    this.popupIsOpen = false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
